import { useEffect, useState } from "react";

import { XCircleIcon } from "@heroicons/react/solid";

import { createErrorMessages } from "@ip-utils/contract";

type Props = {
  error: any;
};

export default function ErrorList({ error }: Props) {
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(() => {
    const createErrors = async () => {
      let messages;
      if (!error.response) {
        messages = createErrorMessages([error.toString()]);
      } else {
        const json = await error.response.json();
        if (json.errors) {
          messages = createErrorMessages(json?.errors);
        } else if (json.message) {
          messages = createErrorMessages([json?.message]);
        } else {
          messages = createErrorMessages([error.toString()]);
        }
      }

      setMessages(messages);
    };

    if (error) {
      createErrors();
    }
  }, [error]);

  const renderErrors = () => {
    return messages.map((e, i) => {
      return <li key={i}>{e}</li>;
    });
  };

  if (!error) {
    return null;
  }
  return (
    <div className="p-4 rounded-md bg-red-50">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="w-5 h-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            There were {messages.length}{" "}
            {messages.length > 1 ? "errors" : "error"}
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="pl-5 space-y-1 list-disc">{renderErrors()}</ul>
          </div>
        </div>
      </div>
    </div>
  );
}
